
import { timeouts } from '../utils/spaConstants';
import { extendCartItems } from './reservation.actions';
import { getProcessUrls } from '../api/apiConstants';
let idleTimeout = null;
let idleWarnTimeout = null;
let cartExpireTimer = null;
let REFRESH_IN = timeouts.refreshIn * 60 * 1000;
let lastActiveTime = localStorage.getItem('lastActiveTime') || Date.now();

// Function to refresh the token
const refreshToken = async () => {
    console.log('Refreshing token...');
    try {
        const response = await fetch(`${getProcessUrls['bookUrl']}/manage-booking/json/keepAlive.page`, {
            credentials: 'include'
        });
        let data = await response.json();
        let token = data.data.tokenStatus === 'Created' ? data.data.tokenObj.appToken : false;

        // If the token was refreshed successfully
        if (token) {
             console.log('Token refreshed successfully:', data);
        } else {
            console.error('Failed to refresh token:', response.statusText);
        }
    } catch (error) {
        console.error('Token refresh failed:', error);
    }
};

// Function to reset lastActiveTime
const resetLastActiveTime = () => {
    lastActiveTime = Date.now();
    localStorage.setItem('lastActiveTime', lastActiveTime);
};

// Function to check if the token should be refreshed
const checkTokenRefresh = () => {
    const timeSinceLastActivity = Date.now() - lastActiveTime;

    // Check if the user is idle (idle condition: timeSinceLastActivity >= timeouts.sessionTimeoutDuration)
    if (timeSinceLastActivity < timeouts.sessionTimeoutDuration * 60 * 1000) {
        // User is active
        refreshToken();

    } else {
        // User is idle
        console.log('User is idle, no token refresh.');
        clearInterval(intervalId);
    }
};

function startIdleTimeout() {
    return (dispatch) => {
        idleWarnTimeout = setTimeout(() => {
            console.log('Your session will timed out in 2 minutes')
        }, timeouts.sessionTimeoutDuration * 60 * 1000)
        idleTimeout = setTimeout(() => {
            clearInterval(intervalId);
            clearIdleTimeout()
            dispatch(userLogOut())
            window.location.replace(`${getProcessUrls['bookUrl']}/manage-booking/logout.page`);
        }, timeouts.sessionTimeoutDuration * 60 * 1000)
    }
}

export const userLogOut = () => {
    return {
        type: 'INIT_LOG_OUT'
    }
}

function clearIdleTimeout() {
    if (idleWarnTimeout) {
        clearTimeout(idleWarnTimeout);
    }
    if (idleTimeout) {
        clearTimeout(idleTimeout);
    }
}
function resetIdleTimeout() {
    return (dispatch) => {
        clearIdleTimeout()
        dispatch(startIdleTimeout())
        resetLastActiveTime();
    }
}
export const initializeIdleTimeout = () => {
    return (dispatch) => {
        const events = [
            'load',
            'mousemove',
            'mousedown',
            'click',
            'scroll',
            'keypress'
        ]

        for (var i in events) {
            window.addEventListener(events[i], function () {
                dispatch(resetIdleTimeout())
            })
        }
        dispatch(startIdleTimeout())
    }
}

export const initiateCartExtendTimer = () => {
    return (dispatch) => {
        if (!cartExpireTimer)
            cartExpireTimer = setTimeout(() => {
                dispatch(extendCartItems());
                cartExpireTimer = null;
            }, timeouts.sessionTimeoutDuration * 60 * 1000) // updated tiemout from 30 to 60 minutes
    }
}

export const clearCartTimer = () => {
    if (cartExpireTimer)
        clearIdleTimeout(cartExpireTimer);
}

// Periodically refresh token
const intervalId = setInterval(checkTokenRefresh, REFRESH_IN);
